import { Mixins, Component } from "vue-property-decorator";
import { CommitableDataSlidePanelWithUploader } from "@/components/slide-panel";
import CavPhoto from '@/lib/models/cav-photo';
import XInput from '@/components/x-input';
import { notEmpty } from '@/lib/helpers';

@Component
export default class PanelCavPhotos extends Mixins<CommitableDataSlidePanelWithUploader<CavPhoto>>(CommitableDataSlidePanelWithUploader) {

  async created() {
    this.create && (this.data = new CavPhoto());
    this.validators = [
      {fn: d => notEmpty(d.file), message: "Le fichier est requis"},
      {fn: d => notEmpty(d.titre), message: "Le titre est requis"}
    ];
  }

  get rootClasses() {
    return ["panel-with-uploader"];
  }

  renderHead() {
    return <span>Téleversement</span>
  }

  renderBody() {
    return (
      <div class="basic">

        {this.renderLightBox()}
        {this.renderUploader()}

        <div class="field">
          <label class="label is-small">Titre du document (*)</label>
          <div class="control">
            <XInput class="input is-small" v-model={this.data.titre} />
          </div>
        </div>

        <div class="field">
          <label class="label is-small">Description</label>
          <div class="control">
            <XInput class="input is-small" v-model={this.data.description} />
          </div>
        </div>

      </div>
    );
  }

}

// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-846b2528/panel-photos.tsx" });